/**
 * La vista previa: el enunciado tal como se verá proyectado.
 *
 * El renderizador se carga **bajo demanda**. Con sus dependencias pesa más que el resto de la
 * aplicación, y el móvil del alumno no debe descargarlo nunca.
 *
 * **Sin región viva.** Anunciar cada pulsación a un lector de pantalla sería insoportable: la
 * región tiene nombre para poder saltar a ella, y nada más.
 */

import { useTranslation } from 'react-i18next';
import { ContenidoMarkdown } from '../markdown/contenido.js';

export function VistaPrevia({ source }: { source: string }): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <section
      aria-label={t('editor.preview')}
      className="rounded-card border-line min-h-32 border-2 p-4"
    >
      {source.trim() === '' ? (
        <p className="text-body text-text-dim italic">{t('editor.previewEmpty')}</p>
      ) : (
        // `prose-clica`, no `clica-prose`: la clase estaba escrita al revés y no aplicaba nada,
        // que es el mismo fallo que la propia hoja de estilos documenta haber corregido una vez.
        <ContenidoMarkdown source={source} className="prose-clica" data-testid="vista-previa" />
      )}
    </section>
  );
}
